// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditPolicy__wrap--21LJ2"};